import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import Vue from 'vue';
import Router from 'vue-router';
import { interopDefault } from './utils';
import scrollBehavior from './router.scrollBehavior.js';

var _877897d2 = function _877897d2() {
  return interopDefault(import('../pages/monitoring.vue'
  /* webpackChunkName: "pages/monitoring" */
  ));
};

var _3cd77a9b = function _3cd77a9b() {
  return interopDefault(import('../pages/redirect_url.vue'
  /* webpackChunkName: "pages/redirect_url" */
  ));
};

var _070769c9 = function _070769c9() {
  return interopDefault(import('../pages/tools/grid.vue'
  /* webpackChunkName: "pages/tools/grid" */
  ));
};

var _68fb5487 = function _68fb5487() {
  return interopDefault(import('../pages/_market/_language/index.vue'
  /* webpackChunkName: "pages/_market/_language/index" */
  ));
};

var _5891980a = function _5891980a() {
  return interopDefault(import('../pages/_market/_language/cart.vue'
  /* webpackChunkName: "pages/_market/_language/cart" */
  ));
};

var _5f71f11f = function _5f71f11f() {
  return interopDefault(import('../pages/_market/_language/help/index.vue'
  /* webpackChunkName: "pages/_market/_language/help/index" */
  ));
};

var _32a2f79e = function _32a2f79e() {
  return interopDefault(import('../pages/_market/_language/login.vue'
  /* webpackChunkName: "pages/_market/_language/login" */
  ));
};

var _4f5984d9 = function _4f5984d9() {
  return interopDefault(import('../pages/_market/_language/lost-password.vue'
  /* webpackChunkName: "pages/_market/_language/lost-password" */
  ));
};

var _6a51e5f4 = function _6a51e5f4() {
  return interopDefault(import('../pages/_market/_language/reset-password.vue'
  /* webpackChunkName: "pages/_market/_language/reset-password" */
  ));
};

var _6e15e933 = function _6e15e933() {
  return interopDefault(import('../pages/_market/_language/signup.vue'
  /* webpackChunkName: "pages/_market/_language/signup" */
  ));
};

var _e1c68aa6 = function _e1c68aa6() {
  return interopDefault(import('../pages/_market/_language/sitemap/index.vue'
  /* webpackChunkName: "pages/_market/_language/sitemap/index" */
  ));
};

var _1bbddda2 = function _1bbddda2() {
  return interopDefault(import('../pages/_market/_language/store-locator/index.vue'
  /* webpackChunkName: "pages/_market/_language/store-locator/index" */
  ));
};

var _52652dae = function _52652dae() {
  return interopDefault(import('../pages/_market/_language/user/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/index" */
  ));
};

var _4e222ecd = function _4e222ecd() {
  return interopDefault(import('../pages/_market/_language/help/confirm.vue'
  /* webpackChunkName: "pages/_market/_language/help/confirm" */
  ));
};

var _2cc9958e = function _2cc9958e() {
  return interopDefault(import('../pages/_market/_language/help/deliveryConfirm.vue'
  /* webpackChunkName: "pages/_market/_language/help/deliveryConfirm" */
  ));
};

var _cb5710ec = function _cb5710ec() {
  return interopDefault(import('../pages/_market/_language/s/catalogue-luminaires.vue'
  /* webpackChunkName: "pages/_market/_language/s/catalogue-luminaires" */
  ));
};

var _16d2a152 = function _16d2a152() {
  return interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
  /* webpackChunkName: "pages/_market/_language/s/home-by-me" */
  ));
};

var _1413ebc3 = function _1413ebc3() {
  return interopDefault(import('../pages/_market/_language/s/lighting.vue'
  /* webpackChunkName: "pages/_market/_language/s/lighting" */
  ));
};

var _9a565ef8 = function _9a565ef8() {
  return interopDefault(import('../pages/_market/_language/s/sustainable-development.vue'
  /* webpackChunkName: "pages/_market/_language/s/sustainable-development" */
  ));
};

var _5ff87f0e = function _5ff87f0e() {
  return interopDefault(import('../pages/_market/_language/t/confirmed.vue'
  /* webpackChunkName: "pages/_market/_language/t/confirmed" */
  ));
};

var _1e08aefa = function _1e08aefa() {
  return interopDefault(import('../pages/_market/_language/t/login.vue'
  /* webpackChunkName: "pages/_market/_language/t/login" */
  ));
};

var _398cfe84 = function _398cfe84() {
  return interopDefault(import('../pages/_market/_language/t/lost-password.vue'
  /* webpackChunkName: "pages/_market/_language/t/lost-password" */
  ));
};

var _35789c20 = function _35789c20() {
  return interopDefault(import('../pages/_market/_language/t/payment.vue'
  /* webpackChunkName: "pages/_market/_language/t/payment" */
  ));
};

var _8bda98f4 = function _8bda98f4() {
  return interopDefault(import('../pages/_market/_language/t/payment-paypal-canceled.vue'
  /* webpackChunkName: "pages/_market/_language/t/payment-paypal-canceled" */
  ));
};

var _4ad5393a = function _4ad5393a() {
  return interopDefault(import('../pages/_market/_language/t/payment-paypal-pending.vue'
  /* webpackChunkName: "pages/_market/_language/t/payment-paypal-pending" */
  ));
};

var _42b717ea = function _42b717ea() {
  return interopDefault(import('../pages/_market/_language/t/refused.vue'
  /* webpackChunkName: "pages/_market/_language/t/refused" */
  ));
};

var _fbcba1f8 = function _fbcba1f8() {
  return interopDefault(import('../pages/_market/_language/t/shipping.vue'
  /* webpackChunkName: "pages/_market/_language/t/shipping" */
  ));
};

var _7ad354ee = function _7ad354ee() {
  return interopDefault(import('../pages/_market/_language/t/signup.vue'
  /* webpackChunkName: "pages/_market/_language/t/signup" */
  ));
};

var _244b81fe = function _244b81fe() {
  return interopDefault(import('../pages/_market/_language/user/gift-card-download.vue'
  /* webpackChunkName: "pages/_market/_language/user/gift-card-download" */
  ));
};

var _31d3d8bf = function _31d3d8bf() {
  return interopDefault(import('../pages/_market/_language/user/gift-cards.vue'
  /* webpackChunkName: "pages/_market/_language/user/gift-cards" */
  ));
};

var _4baf2421 = function _4baf2421() {
  return interopDefault(import('../pages/_market/_language/user/orders/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/orders/index" */
  ));
};

var _528fd2c0 = function _528fd2c0() {
  return interopDefault(import('../pages/_market/_language/user/profile.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile" */
  ));
};

var _ef396d7a = function _ef396d7a() {
  return interopDefault(import('../pages/_market/_language/user/profile/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/index" */
  ));
};

var _d91cc0da = function _d91cc0da() {
  return interopDefault(import('../pages/_market/_language/user/profile/addresses.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/addresses" */
  ));
};

var _64c83414 = function _64c83414() {
  return interopDefault(import('../pages/_market/_language/user/profile/alerts.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/alerts" */
  ));
};

var _a9e3338c = function _a9e3338c() {
  return interopDefault(import('../pages/_market/_language/user/profile/password.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/password" */
  ));
};

var _b10e6a84 = function _b10e6a84() {
  return interopDefault(import('../pages/_market/_language/user/wishlist.vue'
  /* webpackChunkName: "pages/_market/_language/user/wishlist" */
  ));
};

var _327551bc = function _327551bc() {
  return interopDefault(import('../pages/_market/_language/help/merchant/confirm.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/confirm" */
  ));
};

var _2e897c59 = function _2e897c59() {
  return interopDefault(import('../pages/_market/_language/configurator/product/_model.vue'
  /* webpackChunkName: "pages/_market/_language/configurator/product/_model" */
  ));
};

var _707f5814 = function _707f5814() {
  return interopDefault(import('../pages/_market/_language/e/magazine/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/e/magazine/_slug" */
  ));
};

var _52157941 = function _52157941() {
  return interopDefault(import('../pages/_market/_language/help/contact/_form.vue'
  /* webpackChunkName: "pages/_market/_language/help/contact/_form" */
  ));
};

var _7d006271 = function _7d006271() {
  return interopDefault(import('../pages/_market/_language/help/faq/_answer.vue'
  /* webpackChunkName: "pages/_market/_language/help/faq/_answer" */
  ));
};

var _d1013f72 = function _d1013f72() {
  return interopDefault(import('../pages/_market/_language/help/return/_form.vue'
  /* webpackChunkName: "pages/_market/_language/help/return/_form" */
  ));
};

var _81b2c1e6 = function _81b2c1e6() {
  return interopDefault(import('../pages/_market/_language/user/orders/_reference.vue'
  /* webpackChunkName: "pages/_market/_language/user/orders/_reference" */
  ));
};

var _fff99c48 = function _fff99c48() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/index.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/index" */
  ));
};

var _1457fea3 = function _1457fea3() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/messages.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/messages" */
  ));
};

var _b681e34e = function _b681e34e() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/notation.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/notation" */
  ));
};

var _2f85c3b6 = function _2f85c3b6() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/product/_code.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/product/_code" */
  ));
};

var _fc643a54 = function _fc643a54() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/_code.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/_code" */
  ));
};

var _1d171d58 = function _1d171d58() {
  return interopDefault(import('../pages/_market/_language/c/_alias.vue'
  /* webpackChunkName: "pages/_market/_language/c/_alias" */
  ));
};

var _36b6fa39 = function _36b6fa39() {
  return interopDefault(import('../pages/_market/_language/configurator/_model.vue'
  /* webpackChunkName: "pages/_market/_language/configurator/_model" */
  ));
};

var _6a7af65f = function _6a7af65f() {
  return interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/inspirations/_slug" */
  ));
};

var _6a07930e = function _6a07930e() {
  return interopDefault(import('../pages/_market/_language/m/_alias.vue'
  /* webpackChunkName: "pages/_market/_language/m/_alias" */
  ));
};

var _fdc6f9aa = function _fdc6f9aa() {
  return interopDefault(import('../pages/_market/_language/p/_alias.vue'
  /* webpackChunkName: "pages/_market/_language/p/_alias" */
  ));
};

var _fc7249ba = function _fc7249ba() {
  return interopDefault(import('../pages/_market/_language/q/_keyword.vue'
  /* webpackChunkName: "pages/_market/_language/q/_keyword" */
  ));
};

var _e229365e = function _e229365e() {
  return interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/e/_alias/_slug" */
  ));
};

var _d3e9a946 = function _d3e9a946() {
  return interopDefault(import('../pages/_market/_language/index.vue'
  /* webpackChunkName: "" */
  ));
};

var _63bd6b49 = function _63bd6b49() {
  return interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
  /* webpackChunkName: "" */
  ));
};

var _52a6eaad = function _52a6eaad() {
  return interopDefault(import('../pages/_market/_language/s/lighting.vue'
  /* webpackChunkName: "" */
  ));
};

var _4b34c87e = function _4b34c87e() {
  return interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
  /* webpackChunkName: "" */
  ));
};

var _3cb0debb = function _3cb0debb() {
  return interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
  /* webpackChunkName: "" */
  ));
};

var _4aca05f8 = function _4aca05f8() {
  return interopDefault(import('../pages/_market/_language/store-locator/index.vue'
  /* webpackChunkName: "" */
  ));
}; // TODO: remove in Nuxt 3


var emptyFn = function emptyFn() {};

var originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  var onComplete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyFn;
  var onAbort = arguments.length > 2 ? arguments[2] : undefined;
  return originalPush.call(this, location, onComplete, onAbort);
};

Vue.use(Router);
export var routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior: scrollBehavior,
  routes: [{
    path: "/monitoring",
    component: _877897d2,
    name: "monitoring"
  }, {
    path: "/redirect_url",
    component: _3cd77a9b,
    name: "redirect_url"
  }, {
    path: "/tools/grid",
    component: _070769c9,
    name: "tools-grid"
  }, {
    path: "/:market?/:language",
    component: _68fb5487,
    name: "market-language"
  }, {
    path: "/:market?/:language?/cart",
    component: _5891980a,
    name: "market-language-cart"
  }, {
    path: "/:market?/:language?/help",
    component: _5f71f11f,
    name: "market-language-help"
  }, {
    path: "/:market?/:language?/login",
    component: _32a2f79e,
    name: "market-language-login"
  }, {
    path: "/:market?/:language?/lost-password",
    component: _4f5984d9,
    name: "market-language-lost-password"
  }, {
    path: "/:market?/:language?/reset-password",
    component: _6a51e5f4,
    name: "market-language-reset-password"
  }, {
    path: "/:market?/:language?/signup",
    component: _6e15e933,
    name: "market-language-signup"
  }, {
    path: "/:market?/:language?/sitemap",
    component: _e1c68aa6,
    name: "market-language-sitemap"
  }, {
    path: "/:market?/:language?/store-locator",
    component: _1bbddda2,
    name: "market-language-store-locator"
  }, {
    path: "/:market?/:language?/user",
    component: _52652dae,
    name: "market-language-user"
  }, {
    path: "/:market?/:language?/help/confirm",
    component: _4e222ecd,
    name: "market-language-help-confirm"
  }, {
    path: "/:market?/:language?/help/deliveryConfirm",
    component: _2cc9958e,
    name: "market-language-help-deliveryConfirm"
  }, {
    path: "/:market?/:language?/s/catalogue-luminaires",
    component: _cb5710ec,
    name: "market-language-s-catalogue-luminaires"
  }, {
    path: "/:market?/:language?/s/home-by-me",
    component: _16d2a152,
    name: "market-language-s-home-by-me"
  }, {
    path: "/:market?/:language?/s/lighting",
    component: _1413ebc3,
    name: "market-language-s-lighting"
  }, {
    path: "/:market?/:language?/s/sustainable-development",
    component: _9a565ef8,
    name: "market-language-s-sustainable-development"
  }, {
    path: "/:market?/:language?/t/confirmed",
    component: _5ff87f0e,
    name: "market-language-t-confirmed"
  }, {
    path: "/:market?/:language?/t/login",
    component: _1e08aefa,
    name: "market-language-t-login"
  }, {
    path: "/:market?/:language?/t/lost-password",
    component: _398cfe84,
    name: "market-language-t-lost-password"
  }, {
    path: "/:market?/:language?/t/payment",
    component: _35789c20,
    name: "market-language-t-payment"
  }, {
    path: "/:market?/:language?/t/payment-paypal-canceled",
    component: _8bda98f4,
    name: "market-language-t-payment-paypal-canceled"
  }, {
    path: "/:market?/:language?/t/payment-paypal-pending",
    component: _4ad5393a,
    name: "market-language-t-payment-paypal-pending"
  }, {
    path: "/:market?/:language?/t/refused",
    component: _42b717ea,
    name: "market-language-t-refused"
  }, {
    path: "/:market?/:language?/t/shipping",
    component: _fbcba1f8,
    name: "market-language-t-shipping"
  }, {
    path: "/:market?/:language?/t/signup",
    component: _7ad354ee,
    name: "market-language-t-signup"
  }, {
    path: "/:market?/:language?/user/gift-card-download",
    component: _244b81fe,
    name: "market-language-user-gift-card-download"
  }, {
    path: "/:market?/:language?/user/gift-cards",
    component: _31d3d8bf,
    name: "market-language-user-gift-cards"
  }, {
    path: "/:market?/:language?/user/orders",
    component: _4baf2421,
    name: "market-language-user-orders"
  }, {
    path: "/:market?/:language?/user/profile",
    component: _528fd2c0,
    children: [{
      path: "",
      component: _ef396d7a,
      name: "market-language-user-profile"
    }, {
      path: "addresses",
      component: _d91cc0da,
      name: "market-language-user-profile-addresses"
    }, {
      path: "alerts",
      component: _64c83414,
      name: "market-language-user-profile-alerts"
    }, {
      path: "password",
      component: _a9e3338c,
      name: "market-language-user-profile-password"
    }]
  }, {
    path: "/:market?/:language?/user/wishlist",
    component: _b10e6a84,
    name: "market-language-user-wishlist"
  }, {
    path: "/:market?/:language?/help/merchant/confirm",
    component: _327551bc,
    name: "market-language-help-merchant-confirm"
  }, {
    path: "/:market?/:language?/configurator/product/:model?",
    component: _2e897c59,
    name: "market-language-configurator-product-model"
  }, {
    path: "/:market?/:language?/e/magazine/:slug?",
    component: _707f5814,
    name: "market-language-e-magazine-slug"
  }, {
    path: "/:market?/:language?/help/contact/:form?",
    component: _52157941,
    name: "market-language-help-contact-form"
  }, {
    path: "/:market?/:language?/help/faq/:answer?",
    component: _7d006271,
    name: "market-language-help-faq-answer"
  }, {
    path: "/:market?/:language?/help/return/:form?",
    component: _d1013f72,
    name: "market-language-help-return-form"
  }, {
    path: "/:market?/:language?/user/orders/:reference",
    component: _81b2c1e6,
    name: "market-language-user-orders-reference"
  }, {
    path: "/:market?/:language?/help/merchant/:order?/:reference?/contact",
    component: _fff99c48,
    name: "market-language-help-merchant-order-reference-contact"
  }, {
    path: "/:market?/:language?/help/merchant/:order?/:reference?/messages",
    component: _1457fea3,
    name: "market-language-help-merchant-order-reference-messages"
  }, {
    path: "/:market?/:language?/help/merchant/:order?/:reference?/notation",
    component: _b681e34e,
    name: "market-language-help-merchant-order-reference-notation"
  }, {
    path: "/:market?/:language?/help/merchant/:order?/:reference?/contact/product/:code?",
    component: _2f85c3b6,
    name: "market-language-help-merchant-order-reference-contact-product-code"
  }, {
    path: "/:market?/:language?/help/merchant/:order?/:reference?/contact/:code",
    component: _fc643a54,
    name: "market-language-help-merchant-order-reference-contact-code"
  }, {
    path: "/:market?/:language?/c/:alias?",
    component: _1d171d58,
    name: "market-language-c-alias"
  }, {
    path: "/:market?/:language?/configurator/:model?",
    component: _36b6fa39,
    name: "market-language-configurator-model"
  }, {
    path: "/:market?/:language?/inspirations/:slug?",
    component: _6a7af65f,
    name: "market-language-inspirations-slug"
  }, {
    path: "/:market?/:language?/m/:alias?",
    component: _6a07930e,
    name: "market-language-m-alias"
  }, {
    path: "/:market?/:language?/p/:alias?",
    component: _fdc6f9aa,
    name: "market-language-p-alias"
  }, {
    path: "/:market?/:language?/q/:keyword?",
    component: _fc7249ba,
    name: "market-language-q-keyword"
  }, {
    path: "/:market?/:language?/e/:alias?/:slug?",
    component: _e229365e,
    name: "market-language-e-alias-slug"
  }, {
    path: "/",
    component: _d3e9a946,
    name: "market-language-home-fr"
  }, {
    path: "/:market/:language/inspirations*",
    component: _63bd6b49,
    name: "market-language-inspirations-fr"
  }, {
    path: "/:market/:language/inspirationen*",
    component: _63bd6b49,
    name: "market-language-inspirations-de"
  }, {
    path: "/:market/:language/ispirazione*",
    component: _63bd6b49,
    name: "market-language-inspirations-it"
  }, {
    path: "/:market/:language/inspiration*",
    component: _63bd6b49,
    name: "market-language-inspirations-en"
  }, {
    path: "/:market/:language/inspiration*",
    component: _63bd6b49,
    name: "market-language-inspirations-pt"
  }, {
    path: "/:market/:language/inspiracion*",
    component: _63bd6b49,
    name: "market-language-inspirations-es"
  }, {
    path: "/:market/:language/s/inspiratie*",
    component: _63bd6b49,
    name: "market-language-inspirations-nl"
  }, {
    path: "/:market/:language/s/luminaires*",
    component: _52a6eaad,
    name: "market-language-lighting-fr"
  }, {
    path: "/:market/:language/s/leuchten*",
    component: _52a6eaad,
    name: "market-language-lighting-de"
  }, {
    path: "/:market/:language/s/illuminazioni*",
    component: _52a6eaad,
    name: "market-language-lighting-it"
  }, {
    path: "/:market/:language/s/lighting*",
    component: _52a6eaad,
    name: "market-language-lighting-en"
  }, {
    path: "/:market/:language/s/lighting*",
    component: _52a6eaad,
    name: "market-language-lighting-pt"
  }, {
    path: "/:market/:language/s/lamparas*",
    component: _52a6eaad,
    name: "market-language-lighting-es"
  }, {
    path: "/:market/:language/s/verlichting*",
    component: _52a6eaad,
    name: "market-language-lighting-nl"
  }, {
    path: "/:market/:language/s/atelier-deco*",
    component: _4b34c87e,
    name: "market-language-home-by-me-fr"
  }, {
    path: "/:market/:language/s/atelier-arredo*",
    component: _4b34c87e,
    name: "market-language-home-by-me-it"
  }, {
    path: "/:market/:language/s/taller-de-decoracion*",
    component: _4b34c87e,
    name: "market-language-home-by-me-es"
  }, {
    path: "/:market/:language/s/dekowerkstatt*",
    component: _4b34c87e,
    name: "market-language-home-by-me-de"
  }, {
    path: "/:market/:language/s/decor-workshop*",
    component: _4b34c87e,
    name: "market-language-home-by-me-en"
  }, {
    path: "/:market/:language/:alias/:slug",
    component: _3cb0debb,
    name: "market-language-editorial"
  }, {
    path: "/:market/:language/magasins/",
    component: _4aca05f8,
    name: "store-locator"
  }],
  fallback: false
};
export function createRouter() {
  var router = new Router(routerOptions);
  var resolve = router.resolve.bind(router); // encodeURI(decodeURI()) ~> support both encoded and non-encoded urls

  router.resolve = function (to, current, append) {
    if (typeof to === 'string') {
      to = encodeURI(decodeURI(to));
    }

    return resolve(to, current, append);
  };

  return router;
}